import {
  GET_ALL_DOCUMENT_TYPES_DATA,
  GET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA,
  SET_ALL_DOCUMENT_TYPES_DATA,
  SET_FILTER_FIND_UPLOAD_DOCUMENT_HISTORY_CONFIG,
  SET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA,
} from './constants.js';

const getFindUploadDocumentHistoryDataAction = (payload) => ({
  type: GET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA,
  payload,
});

const setFindUploadDocumentHistoryDataAction = (payload) => ({
  type: SET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA,
  payload,
});

const setFilterFindUploadDocumentHistoryConfig = (payload) => ({
  type: SET_FILTER_FIND_UPLOAD_DOCUMENT_HISTORY_CONFIG,
  payload,
});

const getAllDocumentTypesDataAction = (payload) => ({
  type: GET_ALL_DOCUMENT_TYPES_DATA,
  payload,
});

const setAllDocumentTypesDataAction = (payload) => ({
  type: SET_ALL_DOCUMENT_TYPES_DATA,
  payload,
});

export {
  getAllDocumentTypesDataAction,
  getFindUploadDocumentHistoryDataAction,
  setAllDocumentTypesDataAction,
  setFilterFindUploadDocumentHistoryConfig,
  setFindUploadDocumentHistoryDataAction,
};
